import {
    SEND_BULK_PAYMENT_REMINDER,
    SEND_INVOICE,
    SEND_PAYMENT_RECEIPT,
    SEND_PAYMENT_REMINDER,
    SEND_MESSAGE,
    SEND_TENANT_STATEMENT,
    RESEND_MESSAGE
} from './actionTypes';

const sendMessage = ({propertyIds, tenantIds, customMessage}) => ({
    type: SEND_MESSAGE,
    payload: {
        propertyIds,
        tenantIds,
        customMessage
    },
    errors: null
});

const resendMessage = (messageIds) => ({
    type: RESEND_MESSAGE,
    payload: messageIds,
    errors: null
})

const sendInvoice = ({invoiceIds, sendDate = ""}) => ({
    type: SEND_INVOICE,
    payload: {
        invoiceIds,
        sendDate
    },
    errors: null
});

const sendTenantStatement = ({tenantIds}) => ({
    type: SEND_TENANT_STATEMENT,
    payload: {
        tenantIds
    },
    errors: null
});

const sendPaymentReceipt = ({paymentIds}) => ({
    type: SEND_PAYMENT_RECEIPT,
    payload: {
        paymentIds
    },
    errors: null
});

const sendPaymentReminder = ({tenantIds}) => ({
    type: SEND_PAYMENT_REMINDER,
    payload: {
        tenantIds
    },
    errors: null
});


const sendBulkPaymentReminder = ({propertyIds}) => ({
    type: SEND_BULK_PAYMENT_REMINDER,
    payload: {
        propertyIds
    },
    errors: null
});

export {
    sendMessage, sendInvoice,
    sendPaymentReceipt, sendPaymentReminder,
    sendBulkPaymentReminder,
    sendTenantStatement,
    resendMessage
}